"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenContext = void 0;
var react_1 = require("react");
exports.TokenContext = (0, react_1.createContext)(null);
//# sourceMappingURL=token.js.map